export default function () {
    function build(entity) {
        if (!entity) throw Error('No supplied entity.');
        return {
            ...entity,
            stream_chapter_route: streamChapterRoute(entity),
            stream_chapter_starts_long_date: streamChapterStartsLongDate(entity),
            stream_chapter_starts_short_time: streamChapterStartsShortTime(entity),
        };
    }

    async function get(idStreamChapter) {
        let streamChapter = null,
            error = null;
        try {
            const {data} = await useApi('videos').get('stream-chapters/' + idStreamChapter);
            streamChapter = build(data.chapter);
        } catch (e) {
            error = useApiError(e);
        }
        return {streamChapter, error};
    }

    async function post(params) {
        let streamChapter = null,
            error = null;
        try {
            const {data} = await useApi('videos').post('stream-chapters', params);
            streamChapter = build(data.chapter);
        } catch (e) {
            error = useApiError(e);
        }
        if (!streamChapter) streamChapter = params;
        return {streamChapter, error};
    }

    async function patch(idStreamChapter, params) {
        let streamChapter = null,
            error = null;
        try {
            const {data} = await useApi('videos').patch('stream-chapters/' + idStreamChapter, params);
            streamChapter = build(data.chapter);
        } catch (e) {
            error = useApiError(e);
        }
        if (!streamChapter) streamChapter = params;
        return {streamChapter, error};
    }

    async function remove(idStreamChapter) {
        let error = null;
        try {
            await useApi('videos').delete('stream-chapters/' + idStreamChapter);
        } catch (e) {
            error = useApiError(e);
        }
        return {error};
    }

    const UtilityDates = useUtilityDates();

    function streamChapterRoute(entity) {
        if (!entity.id_stream_chapter) return undefined;
        return {
            name: 'live-idStream-idStreamChapter',
            params: {
                idStream: entity.id_stream,
                idStreamChapter: entity.id_stream_chapter,
            },
        };
    }

    function streamChapterStartsLongDate(entity) {
        if (!entity.stream_chapter_starts) return undefined;
        return UtilityDates.printDateTime(entity.stream_chapter_starts, 'dayMonthDate');
    }

    function streamChapterStartsShortTime(entity) {
        if (!entity.stream_chapter_starts) return undefined;
        return UtilityDates.printDateTime(entity.stream_chapter_starts, 'militaryTime');
    }

    return {build, get, post, patch, remove};
}
